import React from "react";
import { Link } from "react-router-dom";
import SectionTitle from "../../components/Common/SectionTitle";
import SingleServiceSeven from "../../components/Service/SingleServiceSeven";

import serviceImg1 from "../../assets/img/maintainace.png";
import serviceImg2 from "../../assets/img/cyber.png";
import serviceImg3 from "../../assets/img/robotics.png";

import serviceImg4 from "../../assets/img/software development.png";
import serviceImg5 from "../../assets/img/technical.png";
import serviceImg6 from "../../assets/img/devops.png";
import serviceImg7 from "../../assets/img/QA.png";
import serviceImg8 from "../../assets/img/digital.png";
import serviceImg9 from "../../assets/img/IT.png";
import serviceImg10 from "../../assets/img/dev.png";
import serviceImg11 from "../../assets/img/data.png";
import serviceImg12 from "../../assets/img/work.png";
import bgImg from "../../assets/img/bg/home12/services-bg.jpg";

const bgStyle = {
  backgroundImage: `url(${bgImg})`,
};

const Service = () => {
  return (
    <React.Fragment>
      <div
        id="rs-services"
        className="rs-services home12-style"
        style={bgStyle}
      >
        <div className="container">
          <SectionTitle
            sectionClass="sec-title4 text-center mb-50"
            subtitleClass="sub-title"
            subtitle="Know More About"
            titleClass="title"
            title="What we do"
          />

          <div className="row">
            <div className="col-lg-3 col-md-6 mb-30">
              <SingleServiceSeven
                serviceClass="services-item"
                serviceImg={serviceImg4}
                serviceTitle="Software Development"
              />
            </div>

            <div className="col-lg-3 col-md-6 mb-30">
              <SingleServiceSeven
                serviceClass="services-item"
                serviceImg={serviceImg2}
                serviceTitle="Cybersecurity"
              />
            </div>

            <div className="col-lg-3 col-md-6 mb-30">
              <SingleServiceSeven
                serviceClass="services-item"
                serviceImg={serviceImg3}
                serviceTitle="AI & Automation"
              />
            </div>

            <div className="col-lg-3 col-md-6 mb-30">
              <SingleServiceSeven
                serviceClass="services-item"
                serviceImg={serviceImg8}
                serviceTitle="Digital Transformation"
              />
            </div>

            <div className="col-lg-3 col-md-6 mb-30">
              <SingleServiceSeven
                serviceClass="services-item"
                serviceImg={serviceImg11}
                serviceTitle="Data Analytics & Business Intelligence"
              />
            </div>

            <div className="col-lg-3 col-md-6 mb-30">
              <SingleServiceSeven
                serviceClass="services-item"
                serviceImg={serviceImg7}
                serviceTitle="Application Testing & Quality Assurance"
              />
            </div>


            <div className="col-lg-3 col-md-6 mb-30">
              <SingleServiceSeven
                serviceClass="services-item"
                serviceImg={serviceImg1}
                serviceTitle="Mobile App Development"
              />
            </div>


            <div className="col-lg-3 col-md-6 mb-30">
              <SingleServiceSeven
                serviceClass="services-item"
                serviceImg={serviceImg5}
                serviceTitle="Technical Capacity Building & Training"
              />
            </div>

            <div className="col-lg-3 col-md-6 mb-30">
              <SingleServiceSeven
                serviceClass="services-item"
                serviceImg={serviceImg9}
                serviceTitle="IT Audit & Compliance"
              />
            </div>

            <div className="col-lg-3 col-md-6 mb-30">
              <SingleServiceSeven
                serviceClass="services-item"
                serviceImg={serviceImg10}
                serviceTitle="Cloud & DevOps Solutions"
              />
            </div>

            <div className="col-lg-3 col-md-6 mb-30">
              <SingleServiceSeven
                serviceClass="services-item"
                serviceImg={serviceImg6}
                serviceTitle="Blockchain & Smart Contracts"
              />
            </div>

            <div className="col-lg-3 col-md-6 mb-30">
              <SingleServiceSeven
                serviceClass="services-item"
                serviceImg={serviceImg12}
                serviceTitle="Workforce & Talent Placement"
              />
            </div>
          </div>

        </div>
      </div>
    </React.Fragment>
  );
};

export default Service;
